import React, { useState, FC, useEffect } from "react";
// package
import {
  Form,
  InputNumber,
  Button,
  AutoComplete,
  Select,
  Space,
  Input,
} from "antd";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { DatePicker as DatePickerJalali } from "antd-jalali";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
// api
import { Autocomplete, GetManufactureList } from "../../api/global";
//context
import { useGlobalState } from "../../context/Provider";
// helper
import { handleQueryString } from "../../helpers/sku.helper";
import { FormItems } from "../../helpers/tableForm.helper";
import { convertToServerFormat } from "../../helpers/function.helper";

type FormSkuProps = {
  setForm: (value: boolean) => void;
  isMobile?: boolean;
  setFormData: (value: any) => void;
};

const TableForm: FC<FormSkuProps> = (props) => {
  const [formItems, setFormItems] = useState<any>([]);
  const [dataSource, setDataSource] = useState<any>([]);
  const [ActiveAutoComplete, setActiveAutoComplete] = useState<string>("");
  const [manufacturesList, setManufacturesList] = useState<any>([]);

  const { pathname } = useLocation();
  const routName = pathname.split("/")[2];
  const { RangePicker } = DatePickerJalali;
  const { setForm, isMobile ,setFormData} = props;
  const navigate = useNavigate();
  const [searchParams]: any = useSearchParams();
  const queriesString: any = Object.fromEntries([...searchParams]);
  const {
    productName,
    ManufacturerId,
    Sku,
    WarehouseId,
    rangeDate,
    CreatorEmail,
    Description,
    EntryAndExit,
  }: any = queriesString;

  const [form] = Form.useForm();
  const { Option } = Select;
  const { warehouserList, langState }: any = useGlobalState();

  useEffect(() => {
    handleGetManufacturesList();
    loadProfile();
  }, []);

  useEffect(() => {
    handleData();
  }, [
    routName,
    manufacturesList,
    dataSource,
    ActiveAutoComplete,
    warehouserList,
  ]);

  const loadProfile = () => {
    form.setFieldsValue({
      productName,
      ManufacturerId,
      Sku,
      WarehouseId,
    });
  };

  const handleGetManufacturesList = () => {
    GetManufactureList().then((res: any) => {
      if (res.status === 200) {
        setManufacturesList(res.data);
      }
    });
  };

  const handleData = () => {
    const currentData = FormItems(
      routName,
      queriesString,
      ActiveAutoComplete,
      dataSource,
      handleSearch,
      manufacturesList,
      warehouserList.data,
      rangeDate,
      langState.locale,
      CreatorEmail,
      Description,
      EntryAndExit
    );
    setFormItems(currentData);
  };

  const handleSearch = (value: string, type: string) => {
    Autocomplete(value, type, routName).then((res: any) => {
      if (res.status === 200) {
        const resultData = res.data.map((item: any) => ({
          text: item.name || item.value,
          value: item.name || item.value,
        }));
        setDataSource(resultData);
      }
    });
  };

  const onFinish = (obj: any) => {
    const newobj = {
      ...obj,
      rangeDate: rangeDate
        ? [
            convertToServerFormat(obj.rangeDate[0]),
            convertToServerFormat(obj.rangeDate[0]),
          ]
        : undefined,
    };
    // console.log("newObj", newobj);

    navigate(`/panel/${routName}?${handleQueryString(newobj)}`);
    setForm(obj);
  };
  const onvaluesChange=(changes:any,values:any[])=>{
    console.log('form changedf')
    setFormData(values);
    setFormData.call(null,values);
    setFormData(values);
    console.log(props.setFormData);
  };

  const handleReset = () => {
    form.resetFields();
    form.submit();
  };

  const handleFocus = (name: string) => {
    setDataSource([]);
    setActiveAutoComplete(name);
  };

  return (
    <Form
     onValuesChange={onvaluesChange}
      form={form}
      layout="inline"
      onFinish={onFinish}
      style={{ alignItems: "end", lineHeight: "20px" }}
      initialValues={{ modifier: "public" }}
    >
      {formItems.map((item: any) =>
        item.activeSection ? (
          item.componentType === "autoComplete" ? (
            <Form.Item
              key={item.name}
              label={item.label}
              name={item.name}
              style={{ flexDirection: "column", alignItems: "start" }}
            >
              <AutoComplete
                dataSource={item.dataSource}
                style={{ width: 140 }}
                onSearch={item.onSearch}
                placeholder={item.placeholder}
                onSelect={(data: string) => console.log("onSeles", data)}
                onFocus={() => handleFocus(item.name)}
              />
            </Form.Item>
          ) : item.componentType === "input" ? (
            <Form.Item
              key={item.name}
              label={item.label}
              name={item.name}
              style={{ flexDirection: "column", alignItems: "start" }}
            >
              <Input
                defaultValue={item.defaultValue}
                placeholder={item.placeholder}
              />
            </Form.Item>
          ) : item.componentType === "select" ? (
            <Form.Item
              key={item.name}
              label={item.label}
              name={item.name}
              style={{ flexDirection: "column", alignItems: "start" }}
            >
              <Select
                showSearch={item.name === "ManufacturerId" && true}
                defaultValue={item.defaultValue}
                style={{ width: 140 }}
                allowClear
                placeholder={item.placeholder}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option!.children as unknown as string).includes(input)
                }
              >
                {item.dataSource.map((item: any) => (
                  <Option value={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          ) : item.componentType === "number" ? (
            <Form.Item
              key={item.name}
              label={item.label}
              name={item.name}
              style={{ flexDirection: "column", alignItems: "start" }}
            >
              <InputNumber min={0} max={100000} />
            </Form.Item>
          ) : item.componentType === "date" ? (
            <Form.Item
              key={item.name}
              label="date"
              name="rangeDate"
              style={{
                flexDirection: "column",
                alignItems: "start",
                width: "190px",
              }}
            >
              <RangePicker
                key={item.name}
                className="my-datepicker"
                size="middle"
                format="YYYY/MM/DD"
              />
            </Form.Item>
          ) : null
        ) : null
      )}
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            width: isMobile ? "75vw" : "100%",
            marginTop: isMobile ? "25px" : "unset",
          }}
        >
          {isMobile && "Submit"}
          <SearchOutlined />
        </Button>
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          danger
          htmlType="button"
          onClick={handleReset}
          style={{
            width: isMobile ? "75vw" : "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Space>
            {isMobile && "Reset"}
            <ReloadOutlined />
          </Space>
        </Button>
      </Form.Item>
    </Form>
  );
};

export default TableForm;
